import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import ewOnePagerUrl from "../assets/ew-one-pager.pdf?url";
import ewPopupUrl from "../assets/ew-popup.png?url";
import { OnboardingProps } from "../common";

export const ExpandedWarrantyOnboarding = memo(
  function ExpandedWarrantyOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const handleAction = () => {
      window.open(ewOnePagerUrl, "_blank");
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText="Learn more"
        description="Check out our new extended warranties capabilities."
        image={ewPopupUrl}
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Extended Warranties now available!"
      />
    );
  },
);
